import { motion } from "framer-motion"
import {sectionConfig as config} from "~/config/_pages/about/works"
import HeroUI from "~/components/ui/hero";
import WordsBanner from "~/assets/about/banner.svg"
import type { ReactNode } from "react";

export default function HowItWorksSection() {
  return (
    <HeroUI.Container reverse wide>
      <HeroUI.Body>
        <HeroUI.Heading title={config.title} suptitle={config.suptitle} />
        <HeroUI.Paragraph>
          {config.caption}
        </HeroUI.Paragraph>
        <FeatureList>
          {config.items.map((item, index) => (
            <FeatureItem key={index} num={index} label={item.label} />
          ))}
        </FeatureList>
      </HeroUI.Body>
      <div className="w-full md:w-55/100">
      <HeroUI.Banner size="md" alt="asd" url={WordsBanner.src}/>
      </div>
    </HeroUI.Container>
  )
}


interface FeatureListProps {
  children: Readonly<ReactNode>
}

const FeatureList = ({ children }: FeatureListProps) => {
  return (
    <ul className="flex flex-col gap-4 text-lg">
      {children}
    </ul>
  )
}

interface FeatureItemProps {
  num: number;
  label: string;
}

const FeatureItem = ({ num, label }: FeatureItemProps) => {
  return (
    <motion.li
      viewport={{once: true}}
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ delay: num * 0.1 }}
      className="flex items-center gap-2"
    >
      <strong className="flex size-10 items-center justify-center rounded bg-[#1b1b1b] pt-1 text-center text-blue-50">
        {num + 1}
      </strong>
      <span>{label}</span>
    </motion.li>
  )
}
